import React, { useEffect, useState, useRef } from 'react';
import { Formik } from 'formik';
import { CSSTransition } from 'react-transition-group';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicSelect from '../../../../components/BasicSelect';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import {CalendarWorkingHoursFormValidationSchema} from './validate';

const CalendarWorkingHoursForm = props => {
  const { interval: initialInterval, freeIntervals, actions } = props;

  const ref = useRef();
  const [interval, setInterval] = useState();
  const [options, setOptions] = useState({ from: [], till: [] });

  useEffect(() => {
    setInterval(initialInterval);
  }, [initialInterval]);

  useEffect(() => {
    if (freeIntervals) {
      initOptions(
        interval && interval.TimeStart ? interval.TimeStart.value : null
      );
      ref.current.focus();
    }
  }, [interval]);

  const initOptions = timeStart => {
    const options = [].concat(
      ...freeIntervals.map(intervals =>
        intervals.filter((record, index) => index !== intervals.length - 1)
      )
    );

    let till = [];
    if (timeStart || timeStart === 0) {
      till =
        freeIntervals.find(intervals =>
          intervals.some(record => record.value === timeStart)
        ) || [];
    }

    setOptions({
      from: options,
      till: till.filter(interval => interval.value > timeStart),
    });
  };

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    actions.onSave(values, resetForm);
  };

  const handleDelete = () => {
    actions.onDelete(interval);
  };

  const handleCancel = () => {
    actions.onCancel();
  };

  const handleChangeTimeStart = (name, value, { setFieldValue }) => {
    setFieldValue(name, value);
    setFieldValue('TimeEnd', null);
    initOptions(value.value);
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik
          enableReinitialize
          initialValues={
            initialInterval || {
              TimeStart: null,
              TimeEnd: null,
            }
          }
          validationSchema={CalendarWorkingHoursFormValidationSchema}
          validateOnBlur={false}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            isValid,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="form__content"
              style={{ maxWidth: '100%' }}
            >
              {isSubmitting && <LoadMask />}
              <>
                <div className="form__row working-hours-form__row">
                  <div className="working-hours-form__element">
                    <BasicSelect
                      ref={ref}
                      isSearchable={false}
                      isDisabled={!interval}
                      name="TimeStart"
                      value={values.TimeStart}
                      isValid={true}
                      required={false}
                      placeholder="From"
                      options={options.from}
                      onChange={(field, value) =>
                        handleChangeTimeStart(field, value, {
                          setFieldValue,
                        })
                      }
                    />
                  </div>

                  <div className="working-hours-form__element">
                    <BasicSelect
                      isSearchable={false}
                      isDisabled={!interval}
                      name="TimeEnd"
                      value={values.TimeEnd}
                      isValid={true}
                      required={false}
                      placeholder="Till"
                      options={options.till}
                      onChange={setFieldValue}
                    />
                  </div>

                  <div className="working-hours-form__element working-hours-form__element--submit">
                    <BasicSubmitButton
                      disabled={!interval || !isValid}
                      controlFunc={handleSubmit}
                      btnWidth={150}
                      btnHeight={40}
                      btnFontWeight={500}
                      btnArrow={true}
                      btnTextColor="#27282d"
                      btnText="Save"
                    />
                  </div>

                  {interval && interval.ScheduleID && (
                    <div className="working-hours-form__element working-hours-form__element--remove">
                      <BasicButton
                        btnWidth={150}
                        btnHeight={40}
                        btnFontSize="0.8571rem"
                        btnFontWeight={600}
                        btnText="Delete"
                        btnArrow={false}
                        btnBg="#fff"
                        btnHoverBg="#f40"
                        controlFunc={handleDelete}
                      />
                    </div>
                  )}

                  {interval && (
                    <div className="working-hours-form__element working-hours-form__element--remove">
                      <BasicButton
                        btnWidth={150}
                        btnHeight={40}
                        btnFontSize="0.8571rem"
                        btnFontWeight={600}
                        btnText="Cancel"
                        btnArrow={false}
                        btnBg="#fff"
                        btnHoverBg="#f40"
                        controlFunc={handleCancel}
                      />
                    </div>
                  )}
                </div>

                {errors.TimeStart && (
                  <div className="form__row working-hours-form__row">
                    <div className="form__error">{errors.TimeStart}</div>
                  </div>
                )}
              </>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default CalendarWorkingHoursForm;
